<ng-container *transloco="let _t">

<span *ngIf="!edit && type!='date'" 
	class="text" 
	[title]="titlePlaceholder+'Cliquer pour éditer'"
	(click)="focus()"
	[innerHtml]="value | replace:'\n':'<br/>'"
></span>

<input *ngIf="edit && type=='text'" 
	type="text"
	[(ngModel)]="value"
	[title]="titlePlaceholder+'(Entrée pour valider)'"
	[placeholder]="placeholder+' (Entrée pour valider)'"
	[focusMe]="true"
	(blur)="blur()"
	(keydown)="blur($event)">

<textarea *ngIf="edit && type=='textarea'"
	[(ngModel)]="value"
	[title]="titlePlaceholder+'Entrée pour valider, Maj+Entrée=à la ligne'"
	[placeholder]="placeholder+' (Entrée pour valider, Maj+Entrée=à la ligne)'"
	[focusMe]="true"
	(blur)="blur()"
	(keydown)="blur($event)"></textarea>

<span *ngIf="!edit && type=='date'" 
	class="date" 
	[title]="titlePlaceholder+'Cliquer pour éditer'"
	(click)="focus()"
>{{value | date:'shortDate':undefined:'fr-FR'}}</span>

<input *ngIf="edit && type=='date'"
	matInput type="date"
	[(ngModel)]="value"
	[title]="placeholder+' - Entrée pour valider'"
	[focusMe]="true"
	(change)="blur($event)"
	(blur)="blur()"
	(keydown)="blur($event)" />



<span *ngIf="!edit && emptyValue" class="placeholder" 
	(click)="focus()">{{placeholder}}</span>

</ng-container>